export function parseApiError(error) {
  const status = error?.response?.status;
  const data = error?.response?.data ?? error?.data ?? error;

  if (typeof data === 'string' && /<html/i.test(data)) {
    if (status === 405) {
      return 'Cannot reach the API server. Rebuild admin-panel with REACT_APP_ADMIN_HOST_API=/be.';
    }
    if (status === 404) {
      return 'API endpoint not found. Check that the backend is running on port 3000.';
    }
    return `Server error (${status || 'unknown'}). Please try again.`;
  }

  if (data?.error?.message) return data.error.message;
  if (data?.message) return data.message;
  if (typeof data === 'string' && data.length < 200 && !/<html/i.test(data)) return data;
  if (typeof error === 'string' && !/<html/i.test(error)) return error;
  if (error?.message && !/<html/i.test(error.message)) return error.message;
  return 'Something went wrong. Please try again.';
}
